// ExternalVideo.js
import React, { useRef, useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Div,
  StyledButton,
  TwoThirds,
  OneThird,
  P,
  ProgressContainer,
  ProgressBar,
  ProgressBarValue,
  Wrapper,
  ProgressText,
  A
} from "./styles"
import VideoPlayer from "../../video-player"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCirclePlay } from "@fortawesome/pro-solid-svg-icons"

const ExternalVideo = ({ handleInputChange, handleRemoveVideo, ...rest }) => {
  const { value, loaded, ...filteredRest } = rest
  const [uploading, setUploading] = useState(false)
  const [removing, setRemoving] = useState(false)
  const fileInputRef = useRef(null)

  const onChange = (event) => {
    event.preventDefault()

    const { name, files } = event.target
    if (handleInputChange !== undefined && files.length > 0) {
      setUploading(true)
      handleInputChange(name, files[0], "external_video")
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current.click()
  }

  const removeVideo = async (event) => {
    const { name } = rest
    event.preventDefault()

    if (window.confirm("Are you sure you wish to delete this video?")) {
      try {
        setRemoving(true)
        await handleRemoveVideo(name, value)
        handleInputChange(name, null, "external_video")
      } catch (error) {
        console.error(error)
      }
      setRemoving(false)
    }
  }

  return (
    <Wrapper>
      <Div>
        <TwoThirds>
          {!!value ? (
            <VideoPlayer videoId={value} />
          ) : (
            <P onClick={handleButtonClick}>
              <FontAwesomeIcon icon={faCirclePlay} />
            </P>
          )}
        </TwoThirds>
        <OneThird padding={!value}>
          <input
            type="file"
            ref={fileInputRef}
            onChange={onChange}
            {...filteredRest}
            accept="video/*"
            style={{ display: "none" }}
          />
          <StyledButton type="button" onClick={handleButtonClick}>
            Upload Video
          </StyledButton>
          {!!value && (
            <A href="#" onClick={removeVideo} disabled={removing}>
              Remove video
            </A>
          )}
        </OneThird>
      </Div>
      {uploading && loaded !== true && (
        <>
          <ProgressContainer>
            <ProgressBar>
              <ProgressBarValue progress={loaded} />
            </ProgressBar>
          </ProgressContainer>
          {<ProgressText>{loaded >= 100 && <span>Saving, please wait...</span>}</ProgressText>}
        </>
      )}
      {removing && (
        <ProgressText style={{ margin: "0 0 20px 0" }}>
          <span>Removing, please wait...</span>
        </ProgressText>
      )}
    </Wrapper>
  )
}

ExternalVideo.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
}

ExternalVideo.defaultProps = {
  handleInputChange: undefined,
  handleRemove: () => {},
  showValidation: false,
  invalid: false
}

export default ExternalVideo
